export default __webpack_public_path__ + "static/media/Beard_1_C3.7b32faa5.svg";